import { Slider } from '@mui/material';
import { VText } from '@vake/ui-kit';
import { FC, useState } from 'react';
import { useDebounce } from './debounce';

export const PathfinderSlider: FC<{
    minDate: number;
    maxDate: number;
    setFilterStartDate: (value: number) => void;
    setFilterEndDate: (value: number) => void;
}> = ({ minDate, maxDate, setFilterStartDate, setFilterEndDate }) => {
    const [timeSliderValues, setValue] = useState<number[]>([minDate, maxDate]);
    const handleSliderChangecommitted = (event: React.SyntheticEvent | Event, newValue: number | number[]) => {
        if (Array.isArray(newValue)) {
            setFilterStartDate(newValue[0]);
            setFilterEndDate(newValue[1]);
        }
    };

    const debounceHandleSliderChange = useDebounce(
        (event, newValue) => handleSliderChangecommitted(event, newValue),
        100 // milliseconds
    );

    const handleSliderChange = (event: React.SyntheticEvent | Event, newValue: number | number[]) => {
        setValue(newValue as number[]);
        debounceHandleSliderChange(event, newValue);
    };

    return (
        <div className="absolute z-[100] w-[40%] left-[30%] top-[90%]">
            <div className="bg-background-primary p-4 rounded">
                <div className="flex justify-between p-2">
                    <VText>From: {new Date(timeSliderValues[0]).toISOString().split('T')[0]}</VText>
                    <VText>Select dates</VText>
                    <VText>To: {new Date(timeSliderValues[1]).toISOString().split('T')[0]}</VText>
                </div>
                <Slider value={timeSliderValues} min={minDate} max={maxDate} onChange={handleSliderChange} />
            </div>
        </div>
    );
};

export const ConfidenceSlider: FC<{
    detectionConfidence: number;
    setDetectionConfidence: (confidence: number) => void;
}> = ({ detectionConfidence, setDetectionConfidence }) => {
    const handleSliderChange = (e: Event | React.SyntheticEvent, newValue: number | number[]) => {
        if (!Array.isArray(newValue)) {
            setDetectionConfidence(newValue);
        }
    };

    return (
        <div className="flex flex-col items-center p-2">
            <VText>Dark detection model confidence</VText>
            <Slider
                value={detectionConfidence}
                min={0}
                max={100}
                step={1}
                valueLabelDisplay="auto"
                valueLabelFormat={(value) => <div>{`${value}%`}</div>}
                onChange={handleSliderChange}
            />
        </div>
    );
};
